import i18n from 'i18n-js';

import en from '../styles/translations/en.json';
import zh from '../styles/translations/zh.json';

/**
 * NOTE: i18n should be refactored as a HOC
 * So that we do not need to map language info into each container
 * to trigger component re-rendering
 */

// Setting current device language
i18n.defaultLocale = 'en';
// FIXME: Disable detecting browser language for the demo purposes.
// i18n.locale = navigator.language.replace(/-\w+/, '');

// show nothing instead of native error message
i18n.missingTranslation = () => undefined;
i18n.fallbacks = true;
i18n.translations = {
  zh,
  en,
};

export default i18n;



// WEBPACK FOOTER //
// ./src/config/i18n.js